<template>
  <el-dialog
    custom-class="linkage-setting"
    :visible.sync="dialogShow"
    width="900px"
    :close-on-click-modal="false"
    :modal-append-to-body="true"
    append-to-body
  >
    <div slot="title">
      <span class="font-lg mr">联动设置</span>
      <el-button
        v-if="!editing"
        type="text"
        icon="el-icon-circle-plus-outline"
        @click="createLinkage()"
      >创建联动</el-button>
    </div>
    <el-scrollbar v-loading="loading" class="linkage-box">
      <template v-for="(linkageItem,index) in linkageArray">
        <LinkageEdit
          :ref="'linkageEdit-' + index"
          :key="'linkageItem-' + index"
          class="mb-lg"
          :linkage-item="linkageItem"
          @cancelEdit="cancelEdit(index)"
          @success="handleSuccess"
          @deleteLinkage="deleteLinkage"
          @edit="editing = true"
        />
      </template>
    </el-scrollbar >
  </el-dialog>
</template>

<script>
import { aiLinkGetall, aiLinkDelete } from "@/api/linkApi";

export default {
  name: "LinkageSetting",

  props: {
    show: {
      type: [Boolean, Number],
      default: false,
    },
  },

  components: {
    LinkageEdit: () => import("./LinkageEdit.vue"),
  },

  data() {
    return {
      loading: false,
      editing: false,
      linkageArray: [],
    };
  },

  computed: {
    dialogShow: {
      get() {
        return this.show;
      },

      set(val) {
        this.$emit("update:show", val);
      },
    },
  },

  created() {
    this.fetchLinkage();
  },

  methods: {
    fetchLinkage() {
      this.loading = true;
      aiLinkGetall({ devid: this.$store.state.devStore.devid }).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.linkageArray = res.data.list;
        }
      });
    },

    createLinkage() {
      this.linkageArray.push({
        senid: null,
        devid: null,
        triggerid: null,
        trigger_type: null,
        min: null,
        max: null,
        sec: null,
        link_senid: null,
        link_sen_value: null,
        editing: true,
      });
      this.editing = true;

      if (this.linkageArray.length <= 1) return;
      //将最新的卡片进入视图
      let _this = this;
      this.$nextTick(() => {
        let key = "linkageEdit-" + (this.linkageArray.length - 1);
        _this.$refs[key][0].$el.scrollIntoView({ behavior: "smooth" });
      });
    },

    deleteLinkage(linkageItem) {
      //增加删除确认
      this.$confirm("此操作将永久删除该联动, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        aiLinkDelete({
          senid: linkageItem.senid,
          devid: linkageItem.devid,
          triggerid: linkageItem.triggerid,
        }).then((res) => {
          if (!res.errno) {
            this.$store.dispatch('fetchDataAction');
            this.$message.success("删除成功");
          } else {
            this.$message.error(res.errmsg);
          }
          this.fetchLinkage();
        });
      });
    },

    cancelEdit(index) {
      this.editing = false;
      //判断是否是新增，是则删除新增的卡片
      if (!this.linkageArray[index].senid) {
        this.linkageArray.splice(index, 1);
      }
      this.fetchLinkage();
    },

    handleSuccess() {
      this.editing = false;
      this.fetchLinkage();
    },
  },
};
</script>

<style lang="scss">
.linkage-setting {
  .el-dialog__body {
    padding-top: 10px;
  }
  .linkage-box {
    height: 500px;
    overflow: auto;
  }
  .header-line {
    background-color: #07c160;
    width: 2px;
    margin-right: 15px;
  }
  .condition {
    padding: 22px 17px 0 17px;
  }
  .task {
    padding: 22px 17px 0 17px;
  }
  .pb-22 {
    padding-bottom: 22px;
  }
  .bottom-border {
    border-bottom: 1px solid #ebeef5;
  }
}
</style>
